/**
 * Where a question's answer codes came from after a person edits the question.
 * The source stamped by generation (`codesFrom`) describes the options as
 * generated, so changing the options or their codes makes it untrue.
 */

export const EDITED_BY_HAND = 'edited by hand';

type Opt = { code?: unknown; label?: unknown };

const same = (a: Opt[], b: Opt[]): boolean =>
  a.length === b.length && a.every((o, i) => String(o.code ?? '') === String(b[i].code ?? '') && String(o.label ?? '') === String(b[i].label ?? ''));

export function codesFromAfterEdit(
  codesFrom: string | undefined,
  before: ReadonlyArray<Opt> | undefined,
  after: ReadonlyArray<Opt> | undefined,
): string | undefined {
  return same([...(before ?? [])], [...(after ?? [])]) ? codesFrom : EDITED_BY_HAND;
}
